// ---------------------------//
//   ===== GO TO SECTION ====
// ---------------------------//
const goToAnchor = () => {
  const allAnchorLinks = document.querySelectorAll('a[href*=\\#]');
  const stickyOffset = document.querySelector('.fixed-header .navbar');


  if (allAnchorLinks.length) {
    for (const anchorLink of allAnchorLinks) {
      anchorLink.addEventListener("click", (e) => {

        const windowUrl = window.location.href.split('#')[0];
        const url = e.target.href.split('#');
        const baseUrl = url[0];
        const hash = url[1];
        //si l'element est sur une autre page
        if (baseUrl === windowUrl && hash !== 'tarteaucitron') {
          e.preventDefault();
          anchorHref(baseUrl, hash, e);
        }

      });
    }
  }

  const anchorHref = (url, hash, event) => {
    //si on ne clique pas sur tarte au citron

    let positionEl = '';
    const offset = 40 + stickyOffset.offsetHeight;
    const anchorID = document.getElementById(hash);


    if (hash === "next-block") {
      positionEl = event.target.closest('.titleBanner').nextElementSibling.offsetTop;
      scroll({
        top: positionEl - offset,
        behavior: "smooth"
      });
    } else {
      if (anchorID != null) {
        positionEl = anchorID.offsetTop;
        scroll({
          top: positionEl - offset,
          behavior: "smooth"
        });

      } else {
        // si l'ancre ne se trouve pas sur la page
        //console.info("l'identifiant n'a pas été trouvé, on redirige sur l'url");
        document.location.href = url;
      }
    }
  }

  if (window.location.hash.length !== 0) {
    const hash = window.location.hash.substring(1);
    if (hash !== 'tarteaucitron') {
      anchorHref(window.location.href, hash);
    }
  }

}

export default goToAnchor;

